import {unByKey} from 'ol/Observable';
import { isNullOrUndefined, valueOrDefault } from '../Util';

const LAYER_ID_ATTRIBUTE = 'id';

var lastId = 1;

class Layer {
    _olLayer = null;
    _legend = null;

   /**
    * 
    * @param {*} options {
    *   name: String, 
    *   doCreateVectorLayer: (function(): ol.layer.Vector),
    *   doCreateLegend: (function(): LayerLegend)
    *   layerStartedLoading: (function(layer: Layer)),
    *   layerFinishedLoading: (function(layer: Layer, sourceState: String)),
    *   createFeatureSummary: (function(feature): FeatureSummary),
    *   multipleFeaturesSelection: boolean
    * }
    */
    constructor(options){
        this.id = lastId++;
        this.name = options.name;
        this.doCreateOLLayer = options.doCreateOLLayer;
        this.doCreateLegend = options.doCreateLegend;
        this.layerStartedLoading = options.layerStartedLoading;
        this.layerFinishedLoading = options.layerFinishedLoading;
        this.createFeatureSummary = options.createFeatureSummary;
        this.multipleFeaturesSelection = valueOrDefault(options.multipleFeaturesSelection, false);
        this.disableSelect = options.disableSelect
    }

    get olLayer(){
        if(!this._olLayer){
            this._olLayer = this.doCreateOLLayer();
            Layer.setLayerIdInOLLayer(this._olLayer, this.id);
            
            /*
            * TODO o código abaixo, que monitora notifica quando a carga da camada VectorLayer termina, 
            * provavelmente deverá ser alterado para tratar camadas openlayers com 
            * classes diferentes de VectorLayer (ImageLayer ou TileLayer).
            */
            const listenerKey = this._olLayer.getSource().on('change', event => {
                this.fireLayerFinishedLoading(event.target.getState());
                unByKey(listenerKey);
            });
            this.fireLayerStartedLoading();        
        }
        return this._olLayer;
    }

    fireLayerStartedLoading = () => {
        if(this.layerStartedLoading){
            this.layerStartedLoading(this);
        }
    }

    fireLayerFinishedLoading = (sourceState) => {
        if(this.layerFinishedLoading){
            this.layerFinishedLoading(this, sourceState);
        }
    }

    static getLayerIdFromOLLayer(olLayer){
        if(isNullOrUndefined(olLayer)){
            return undefined;
        }

        return olLayer.get(LAYER_ID_ATTRIBUTE);
    }

    static setLayerIdInOLLayer(olLayer, layerId){
        olLayer.set(LAYER_ID_ATTRIBUTE, layerId, true);
    }

    get legend(){
        if(!this._legend && this.legendExists){
            this._legend = this.doCreateLegend(this)
            this._legend.layer = this;
        }
        return this._legend
    }

    get legendExists(){
        if(this.doCreateLegend){
            return true;
        }
        return false;
    }
}

export default Layer